import colorbox from '../../node_modules/jquery-colorbox/jquery.colorbox.js';
import InputMask from "inputmask";

$(function () {
    function getAllDataAttributes(el) {
        let data = {};
        [].forEach.call(el.attributes, function(attr) {
            if (/^data-/.test(attr.name)) {
                var camelCaseName = attr.name.substr(5).replace(/-(.)/g, function ($0, $1) {
                    return $1.toUpperCase();
                });
                data[camelCaseName] = attr.value;
            }
        });
        return data;
    }
    function setEqualHeight($element, diffHeight = 0) {
        let height = 0;
        $element.each(function (i, e) {
            height = height < $(e).outerHeight() ? $(e).outerHeight() : height;
        });
        height = height === 0 ? diffHeight : height;
        $element.each(function (i, e) {
            $(e).css({height: height + 'px'});
        });
    }

    setEqualHeight($('.promo-catalog-item__caption'));
    
    const inputMask = () => {
        const im = new InputMask('+7 (999)-999-99-99', {"inputmode": 'decimal', "clearIncomplete": true});
        im.mask($('[type="tel"],[data-mask="phone"]'));
    }
    inputMask();

    $('[data-popup-form]').click(function (e) {
        e.preventDefault();
        var form = $(this).data('popup-form');
        var data = getAllDataAttributes(this);
        data.page = document.location.href;
        $.colorbox({
            href: '/ajax/form/product-promo.html',
            data,
            maxWidth: '100%',
            maxHeight: '100%',
            opacity: false,
            onComplete: function () {
                inputMask();
            }
        });
    });

    // плавный скрол до элемента и отключение действий для ссылок "#"
    $('a[href^="#"]').click(function (e) {
        e.preventDefault();
        const offset = $(this).data('offset') ? $(this).data('offset') : 0;
        if ($(this).attr('href').length > 1) {
            scroll2element(
                $($(this).attr('href')),
                1000,
                offset,
                false
            );
        }
        if ($(this).data('sale-calc')) {
            $('#' + $(this).data('sale-calc')).trigger('click');
        }

    });

    function scroll2element($el, speed, offset, edges) {
        if (speed == undefined) speed = 'slow';
        if (offset == undefined) offset = 50;
        if (edges == undefined) edges = true;
    
        var scroll = $el.offset().top - offset,
            topEdge = window.pageYOffset,
            bottomEdge = window.pageYOffset + document.documentElement.clientHeight,
            bNeedScroll = edges ? (scroll < topEdge || scroll > bottomEdge) : true;
    
        if (bNeedScroll) {
            $('html, body').animate({
                scrollTop: scroll + 'px'
            }, speed);
        }
    }
});
